<template>
  <div v-if="itemSameCollections.length > 0" class="artwork-suggestion">
    <div class="suggestion-title">More from same collection</div>
    <div class="suggestion-wrapper">
      <!-- <NftCard
        v-for="item in itemSameCollections"
        :key="item.nftId"
        :nftData="formatNftCardData(item)"
      /> -->
      <div v-for="data in itemSameCollections" :key="data.nftId">
        <bunicorn-nft-card
          v-if="getNftNameFromAddress(data.nftContract) === 'Bunicorn'"
          :nftData="formatNftCardData(data)"
        />
        <trainer-nft-card
          v-if="getNftNameFromAddress(data.nftContract) === 'Trainer'"
          :nftData="formatNftCardData(data)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import rf from '@/requests/RequestFactory';
// import NftCard from '@/components/BaseComponents/NftCard.vue';
import BunicornNftCard from '@/components/BunicornGame/BunicornNftCard.vue';
import TrainerNftCard from '@/components/BunicornGame/TrainerNftCard.vue';
import { getSellMethod } from '@/helpers';
import config from '@/config';
import _ from 'lodash';

export default {
  components: {
    // NftCard,
    BunicornNftCard,
    TrainerNftCard
  },
  props: ['nftContract', 'nftId'],
  data() {
    return {
      itemSameCollections: []
    };
  },
  async mounted() {
    const itemSameCollectionRes = await rf
      .getRequest('GameMarketplaceRequest')
      .getItemSameCollection(this.nftContract, this.nftId);
    if (itemSameCollectionRes) {
      this.itemSameCollections = itemSameCollectionRes;
    }
  },
  computed: {
    bunicornGameConfig() {
      const projects = config.projects;
      return projects.bunicornGame;
    }
  },
  methods: {
    getSellMethod,
    getNftNameFromAddress(contractAddress) {
      if (!this.bunicornGameConfig || !contractAddress) {
        return '';
      }
      const nftCollection = _.find(
        this.bunicornGameConfig.collections || [],
        collection => {
          return collection.nftContract === contractAddress;
        }
      );
      return nftCollection ? nftCollection.nftName : '';
    },
    formatNftCardData(data) {
      const metaData = data.metaData || {};
      return {
        nftContract: data.nftContract,
        nftId: data.nftId,
        nftImage: metaData.image,
        nftName: metaData.name,
        nftAttributes: metaData.attributes,
        sellMethod: this.getSellMethod(data.sellMethod),
        price: data.minPrice,
        packId: data.packId,
        sellerAddress: data.sellerAddress,
        collectionType: 1,
        currencyAddress: data.currency
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/config/_variables';

.artwork-suggestion {
  margin-top: 114px;
  .suggestion-title {
    font-family: Inter-SemiBold;
    font-size: 26px;
    color: #203a54;
  }
  .suggestion-wrapper {
    display: flex;
    justify-content: space-around;
    max-width: 900px;
    margin: 30px auto;
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .artwork-suggestion {
    .suggestion-wrapper {
      margin-top: 30px;
      display: flex;
      overflow-x: auto;
      justify-content: flex-start;
    }
  }
}
</style>
